import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, computed, inject, input, signal } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Button } from 'primeng/button';

import { PushNotificacionesService } from '../../../core/services/push-notificaciones.service';
import { esAppInstalada } from '../../../core/utils/plataforma';
import { PushPermisoDenegadoError } from '../../interfaces/push.interface';

@Component({
  selector: 'app-aviso-activar-push',
  standalone: true,
  imports: [Button],
  templateUrl: './aviso-activar-push.component.html',
  styleUrl: './aviso-activar-push.component.scss',
})
export class AvisoActivarPushComponent implements OnInit {
  private readonly push = inject(PushNotificacionesService);
  private readonly messages = inject(MessageService);

  /** Separa la franja de los bordes cuando va dentro de una columna. */
  readonly inset = input(false);
  readonly activando = signal(false);
  readonly visible = computed(
    () => esAppInstalada() && this.push.estado() === 'inactivo',
  );

  ngOnInit(): void {
    void this.push.refrescarEstado();
  }

  activar(): void {
    if (this.activando()) return;
    this.activando.set(true);

    this.push
      .activar()
      .then(() => {
        this.messages.add({
          severity: 'success',
          summary: 'Notificaciones activadas',
          detail: 'Este dispositivo va a recibir los avisos de Mayorap.',
          life: 4000,
        });
      })
      .catch((error: unknown) => {
        if (error instanceof PushPermisoDenegadoError) {
          void this.push.refrescarEstado();
          this.messages.add({
            severity: 'warn',
            summary: 'Permiso no otorgado',
            detail: 'Sin permiso, el navegador no puede mostrar notificaciones.',
            life: 6000,
          });
          return;
        }
        this.messages.add({
          severity: 'error',
          summary: 'No pudimos activar las notificaciones',
          detail:
            error instanceof HttpErrorResponse && error.status === 503
              ? 'Las notificaciones todavía no están configuradas en el servidor.'
              : 'El navegador no aceptó la suscripción. Intentá de nuevo.',
          life: 6000,
        });
      })
      .finally(() => this.activando.set(false));
  }
}
